import { put, call } from 'redux-saga/effects';
import { 
  donorService, 
  updateDonorService,
  selfserviceDonorService,
  notifyDonorsService, 
  fetchAllDonorsService,
  fetchDonorByPhoneService,
  addVolunteerDonorService,
  addActualDonorService,
  deleteVolunteerDonorService,
  importDonorsService,
  sendOTPDonorService  
 } from '../services/donorService';

import * as types from '../actions'

export function* donorSaga(payload) {
  try {
    const response = yield call(donorService, payload);
    yield put({ type: types.DONOR_SUBMIT_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.DONOR_SUBMIT_ERROR, error })
  }
}

export function* updateDonorSaga(payload) {
  try {
    const response = yield call(updateDonorService, payload);
    yield put({ type: types.DONOR_UPDATE_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.DONOR_UPDATE_ERROR, error })
  }
}

export function* selfserviceDonorSaga(payload) {
  try {
    const response = yield call(selfserviceDonorService, payload);
    yield put({ type: types.DONOR_SELFSERVICE_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.DONOR_SELFSERVICE_ERROR, error })
  }
}

export function* notifyDonorsSaga(payload) {
  try {
    const response = yield call(notifyDonorsService, payload);
    yield put({ type: types.NOTIFY_DONORS_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.NOTIFY_DONORS_ERROR, error })
  }
}

export function* fetchAllDonorsSaga(payload){
  try {
    const response = yield call(fetchAllDonorsService, payload);
    yield put({ type: types.ALL_DONORS_FETCH_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.ALL_DONORS_FETCH_ERROR, error })
  }
}

export function* fetchDonorByPhoneSaga(payload){
  try {
    const response = yield call(fetchDonorByPhoneService, payload);
    yield put({ type: types.DONOR_FETCHBYPHONE_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.DONOR_FETCHBYPHONE_ERROR, error })
  }
}

export function* addVolunteerDonorSaga(payload){
  try {
    const response = yield call(addVolunteerDonorService, payload);
    yield put({ type: types.ADD_VOLUNTEER_DONOR_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.ADD_VOLUNTEER_DONOR_ERROR, error })
  }
}

export function* addActualDonorSaga(payload){
  try {
    const response = yield call(addActualDonorService, payload);
    yield put({ type: types.ADD_ACTUAL_DONOR_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.ADD_ACTUAL_DONOR_ERROR, error })
  }
}

export function* deleteVolunteerDonorSaga(payload){
  try {
    const response = yield call(deleteVolunteerDonorService, payload);
    yield put({ type: types.DELETE_VOLUNTEER_DONOR_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.DELETE_VOLUNTEER_DONOR_ERROR, error })
  }
}

export function* importDonorsSaga(payload){
  try {
    const response = yield call(importDonorsService, payload);
    yield put({ type: types.IMPORT_DONORS_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.IMPORT_DONORS_ERROR, error })
  }
}

export function* sendOTPDonorSaga(payload){
  try {
    const response = yield call(sendOTPDonorService, payload);
    yield put({ type: types.SEND_OTP_DONOR_SUCCESS, response, });
  } catch(error) {
    yield put({ type: types.SEND_OTP_DONOR_ERROR, error })
  }
}